import { render, staticRenderFns } from "./searchInResult.vue?vue&type=template&id=a35e3016&scoped=true&"
import script from "./searchInResult.vue?vue&type=script&lang=js&"
export * from "./searchInResult.vue?vue&type=script&lang=js&"
import style0 from "./searchInResult.vue?vue&type=style&index=0&id=a35e3016&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35e3016",
  null
  
)

export default component.exports